// Friendly display names for module keys, used in breadcrumbs etc.
export const MODULE_NAMES = {
  tasks: "Tasks",
  crm: "CRM",
  projects: "Projects",
  hr: "HR",
  accounting: "Accounting",
  lending: "Financial Services",
};

// Breadcrumb parent for a collection: its module's name, else "Collections".
export function collectionParent(et) {
  if (et?.module_key && MODULE_NAMES[et.module_key]) return MODULE_NAMES[et.module_key];
  return "Collections";
}
